// 這邊放一些共運元件的翻譯，例如：header/footer/toast等等
// 盡量放所有頁面都會用到的翻譯

const commonMessages = {
  en: {
    header: {
      bets: "Bets",
      main: "Main"
    },
    agent: {
      exposure: "Exposure",
      account: "Account",
      change: "Change"
    },
    button: {
      demo: "Demo",
      today: "Today",
      yesterday: "Yesterday",
      login: "Login"
    },
    member: {
      multiMarkets: "Multi Markets"
    },
    footer: {
      inPlay: "In-Play",
      leagues: "Leagues",
      horse: "Horse",
      greyHound: "GreyHound",
      home: "Home",
      sports: "Sports"
    },
    text: {
      odds: "Odds",
      tomorrow: "Tomorrow",
      InPlay: "In-Play",
      result: "Result",
      loading: "Loading...",
      logout: "LOGOUT",
      changePassword: "Change Password",
      newPassword: "New Password",
      newPasswordConfirm: "New Password Confirm",
      oldPassword: "Old Password",
      betHeaderStake: "Stake",
      defaultStake: "Default stake",
      quickStakes: "Quick Stakes",
      editStakes: "Edit Stakes"
    },
    msg: {
      acceptAnyOdds: "Accept Any Odds",
      acceptAnyPrice: "Accept Any Price",
      oddsHighlight: "Highlight when odds change",
      amoutsLess: "Coin amounts less than 6"
    }
  },
  cn: {
    header: {
      bets: "\u6CE8\u5355",
      main: "\u4E3B\u8981"
    },
    agent: {
      exposure: "\u98CE\u9669\u627F\u62C5\u503C",
      account: "\u6237\u53E3",
      change: "\u66F4\u6539"
    },
    button: {
      demo: "Demo",
      today: "\u4ECA\u5929",
      login: "\u767B\u5165",
      yesterday: "\u6628\u5929"
    },
    member: {
      multiMarkets: "\u6211\u7684\u5E02\u573A"
    },
    footer: {
      inPlay: "\u8D70\u5730",
      leagues: "\u8054\u8D5B",
      horse: "\u8D5B\u9A6C",
      greyHound: "\u8D5B\u72D7",
      home: "\u4E3B\u9875",
      sports: "\u8FD0\u52A8"
    },
    text: {
      odds: "\u8D54\u7387",
      tomorrow: "\u660E\u5929",
      InPlay: "\u8D70\u5730",
      result: "\u6210\u7EE9",
      loading: "\u5904\u7406\u4E2D",
      logout: "\u767B\u51FA",
      changePassword: "\u6362\u5BC6\u7801",
      newPassword: "\u65B0\u5BC6\u7801",
      newPasswordConfirm: "\u786E\u8BA4\u65B0\u5BC6\u7801",
      oldPassword: "\u65E7\u5BC6\u7801",
      betHeaderStake: "\u91D1\u989D",
      defaultStake: "\u9884\u8BBE\u91D1\u989D",
      quickStakes: "\u5FEB\u901F\u91D1\u989D",
      editStakes: "\u4FEE\u6539\u91D1\u989D"
    },
    msg: {
      acceptAnyOdds: "\u63A5\u53D7\u4EFB\u4F55\u8D54\u7387",
      acceptAnyPrice: "\u63A5\u53D7\u4EFB\u4F55\u50F9\u683C",
      oddsHighlight: "\u8D54\u7387\u53D8\u65F6\u8981\u95EA\u70C1",
      amoutsLess: "\u7B79\u7801\u4F4E\u4E8E\uFF16\u79CD"
    }
  }
}

export default commonMessages
